var _g, _g2, _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYellowSquare(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#fff700",
    width: "20px",
    height: "20px",
    viewBox: "0 0 48.00 48.00",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    stroke: "#fff700",
    transform: "rotate(45)",
    strokeWidth: 0.00048000000000000007,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st1{display:none}")), /*#__PURE__*/React.createElement("g", {
    id: "Your_Icons"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h48v48H0V0z",
    style: {
      fill: "none"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.981 40.019h32.038V7.981H7.981v32.038z",
    id: "Shopicon_00000005233862153072290020000010038958663075050425_"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowSquare);
export default __webpack_public_path__ + "static/media/yellow-square.93e4a8aac4000303edbbf547e756e250.svg";
export { ForwardRef as ReactComponent };